<template>
  <div class="container" v-loading="!isInit">
    <div class="course-panel" ref="coursePaneRef">
      <div class="course-panel-body">
        <div class="condition-panel" v-if="false">
          <div class="condition-item" v-for="(courseTipItem, courseTipIndex) in courseFilterTips" :key="courseTipIndex">
            <span>{{ courseTipItem.tipText }}</span>
            <template v-if="courseTipItem.filterItem.name !== '文书类型'">
              <i
                v-if="['全文检索', '引用法条', '案由'].includes(courseTipItem.filterItem.name)"
                class="el-icon-close close-btn"
                @click="removeFilter({ filterItem: courseTipItem.filterItem, contentArr: courseTipItem.contentArr })"
              ></i>
              <i
                v-else
                class="el-icon-close close-btn"
                @click="removeFilter({ filterItem: courseTipItem.filterItem })"
              ></i>
            </template>
          </div>
        </div>
        <div class="course-panel-item" v-if="false">
          <span class="label">文书类型</span>
          <div class="course-panel-item-wrapper">
            <el-radio-group class="input" v-model="instrumentType" @change="changeInstrumentType">
              <el-radio label="裁判文书" />
              <el-radio label="检察文书" />
            </el-radio-group>
          </div>
        </div>
        <div
          class="course-panel-item"
          v-for="label in filterList"
          :key="label.name"
          :style="label.mulits ? 'display: flex; flex-wrap: wrap;' : ''"
        >
          <template v-if="!label.isBaseNatureCase || instrumentType === '裁判文书'">
            <span class="label" v-if="(label.mulits && label.result.length > 0) || !label.mulits">
              {{ label.name }}
            </span>
            <div
              class="course-panel-item-wrapper"
              v-if="['version', 'base_title', 'base_caseNumber'].includes(label.key)"
            >
              <div class="input">
                <el-input
                  :style="{ width: selectWidth }"
                  clearable
                  v-model="label.value"
                  :placeholder="label.placeholder || '请输入关键词'"
                />
              </div>
            </div>
            <div v-if="['全文检索'].includes(label.name)" class="panel-item-warp">
              <fullTextSelect :label="label" />
            </div>
            <div v-if="['案由'].includes(label.name) && isInit" class="panel-item-warp">
              <fullReasonSelect :label="label" />
            </div>
            <div v-if="['引用法条'].includes(label.name)" class="panel-item-warp">
              <div v-for="(val, index) in label.result" :key="index" class="input para-search">
                <el-select
                  class="left-select"
                  v-model="val.keyword"
                  :style="{ width: '144px' }"
                  clearable
                  filterable
                  default-first-option
                  popper-class="pop-select"
                  placeholder="全部法律"
                  @change="(val.value = ''), (val.lawRes = [])"
                >
                  <el-option-group v-for="group in lawView.buckets" :key="group.id" :label="group.key">
                    <el-option v-for="item in group.title.buckets" :key="item.id" :value="item.key">
                      <span slot="label">{{ item.key }}</span>
                    </el-option>
                  </el-option-group>
                </el-select>

                <el-select
                  class="right-select"
                  v-model="val.value"
                  clearable
                  filterable
                  default-first-option
                  remote
                  :placeholder="!val.keyword ? '请先选择法律' : '输入法条关键词搜索，多关键词用空格隔开'"
                  :style="{ width: '356px', marginRight: '7px' }"
                  :remote-method="e => remoteMethod(e, val)"
                  :loading="remoteLoading"
                  popper-class="law-pop-select"
                  :disabled="!val.keyword"
                >
                  <el-option v-for="item in val.lawRes" :key="item.id" :label="item.lawTitle" :value="item.lawTitle">
                    <div>{{ item.lawTitle }}</div>
                    <div class="single-ellipsis">
                      <span
                        v-for="(content, contentIdx) in item.highlight.lawContent"
                        :key="contentIdx"
                        v-html="content"
                      >
                      </span>
                    </div>
                  </el-option>
                </el-select>

                <span class="operation" @click="addRes(label)"><i class="el-icon-circle-plus-outline"></i></span>
                <span class="operation" @click="removeRes(label, index)"><i class="el-icon-remove-outline"></i></span>
              </div>

              <div class="text-group-type" v-if="label.result.length > 1">
                <div slot="reference" class="group-type-btn">
                  <span @click="label.type = 'and'" class="group-text" :class="[label.type === 'and' ? 'active' : '']"
                    >且</span
                  >
                  <span @click="label.type = 'or'" class="group-text" :class="[label.type === 'or' ? 'active' : '']"
                    >或</span
                  >
                </div>
              </div>
              <div class="line" v-if="label.result.length > 1">
                <span class="line-item line-item-top"></span>
                <span class="line-item line-item-bottom"></span>
              </div>
            </div>
            <div class="course-panel-item-wrapper" v-else>
              <div style="width:500px;display: inline-block;" v-if="label.key == 'full_base_court'">
                <configureRemoteSelect
                  :ref="label.key"
                  :item="label"
                  :type="label.key"
                  :checkAllName="label.checkAllName"
                  :relationParent="courtLevel"
                  @valueChange="remoteSelectChange"
                />
              </div>

              <div class="mulit-personal-crime" v-else-if="label.key === 'mulit_personal_crime'">
                <div class="mulit-personal-crime-content">
                  <el-checkbox
                    class="personal-crime-checkbox"
                    v-model="label.value.singlePersonal"
                    label="单主体"
                    border
                  />
                  <el-checkbox
                    class="personal-crime-checkbox"
                    v-model="label.value.mulitPersonal"
                    label="多主体"
                    border
                  />
                  <el-checkbox
                    class="personal-crime-checkbox"
                    v-model="label.value.singleCrime"
                    label="单案由"
                    border
                  />
                  <el-checkbox class="personal-crime-checkbox" v-model="label.value.mulitCrime" label="多案由" border />
                </div>
              </div>
              <el-select
                v-else-if="label.key == 'base_nature'"
                v-model="label.value"
                :style="{ width: '500px' }"
                clearable
                filterable
                default-first-option
                multiple
                @change="multSelectHandle(label.key)"
                :ref="label.key"
                placeholder="请输入搜索或选择"
              >
                <el-option v-for="(val, valIndex) in natureList" :key="valIndex" :value="val"> </el-option>
              </el-select>
              <el-cascader
                v-else-if="label.key == 'base_caseType'"
                :key="'base_caseType' + cascaderIndex"
                :style="{ width: '500px' }"
                class="crime-select"
                v-model="label.value"
                :options="caseTypeList"
                :props="{ multiple: false, label: 'name', value: 'name', expandTrigger: 'hover' }"
                :show-all-levels="false"
                @change="changeCaseType(label.value)"
                label="name"
                clearable
              >
              </el-cascader>
              <div style="width:500px;" v-else-if="label.key == 'full_procedureType'">
                <configureRemoteSelect
                  v-if="isInit"
                  :ref="label.key"
                  :relationParent="casePickType"
                  :item="label"
                  :type="label.key"
                  :checkAllName="label.checkAllName"
                  @valueChange="remoteSelectChange"
                  @reset="label.resetFunc()"
                />
              </div>
              <el-select
                v-else-if="label.inputType == 'select'"
                v-model="label.value"
                :style="{ width: '500px' }"
                clearable
                filterable
                default-first-option
                :multiple="label.isSingle ? false : true"
                @change="multSelectHandle(label.key)"
                :ref="label.key"
                placeholder="请输入搜索或选择"
              >
                <el-option v-for="(val, index) in label.data" :key="index" :value="val"></el-option>
              </el-select>
              <div v-else-if="label.inputType == 'date'">
                <el-date-picker
                  :style="{ width: '238px' }"
                  v-model="label.value[0]"
                  type="date"
                  :default-value="defaultDate"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
                <span> 至 </span>
                <el-date-picker
                  :style="{ width: '238px' }"
                  v-model="label.value[1]"
                  type="date"
                  :default-value="defaultDate"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </div>
              <!-- <el-autocomplete
                v-model="label.value"
                popper-class="cirme-input-popper"
                v-else-if="label.key == 'base_caseNumber'"
                :style="{ width: '500px' }"
                clearable
                :fetch-suggestions="(str, cb) => cb([true])"
                placeholder="请输入关键词"
                :maxlength="300"
              >
                <div class="course-create-input-tip" @click.stop="() => ''">
                  <div class="course-create-input-tip-title">输入提示：</div>
                  <div class="course-create-input-tip-item">
                    “|”竖线的符号表示“或”的关系（如：（2020）豫1727民初4571号 |（2021）吉0523民初46号）
                  </div>
                </div>
              </el-autocomplete> -->
              <el-input
                :style="{ width: '500px' }"
                v-else-if="label.inputType === 'inputText'"
                v-model="label.value"
                placeholder="请输入"
              />

              <span
                class="operation"
                :style="{ margin: '0 0 0 7px' }"
                v-if="label.edit"
                @click.stop="removeFiled(label)"
                ><i class="el-icon-remove-outline"></i
              ></span>
            </div>
            <div class="course-panel-item-tip" v-if="label.tipText">
              <span>{{ label.tipText }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="course-panel-menu">
      <div class="menu-title-text">添加检索类型</div>
      <div class="new-filter-ul">
        <div
          class="new-filter-item"
          v-for="(field, index) in filedList"
          :key="index"
          @click="addFields(field)"
          :class="hadFileds(field) ? 'disabled-filter-item' : ''"
          v-show="!field.isBaseNatureCase || instrumentType === '裁判文书'"
        >
          <span><i class="el-icon-plus"></i></span>
          <span>{{ field.name }}</span>
        </div>
      </div>
    </div>
    <div class="normal-footer" v-if="!justFilter">
      <el-button @click="resetHandle()" :style="{ background: '#fff' }">
        <span>重置条件</span>
      </el-button>
      <el-button type="primary" @click="confirmHandle()">
        <span>立即检索</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
import publicUtilFunc from '@/common/js/publicUtil';
import { find, findIndex, uniqueId, cloneDeep, groupBy } from 'lodash';
import provinceJson from '@/assets/area/province_city';
import configureRemoteSelect from '@/components/configureRemoteSelect';
import fullTextSelect from '@/components/fullTextSelect/index.vue';
import fullReasonSelect from '@/components/fullReasonSelect/index.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';

const baseNature = ['判决书', '裁定书', '调解书', '决定书', '通知书', '令', '其他'];
const procuratorateNature = [
  '起诉书',
  '不起诉决定书',
  '抗诉书',
  '刑事申诉复查决定书',
  '刑事赔偿决定书',
  '其他法律文书'
];

import { defaultFilterList, optionFilterList } from '@/constant';
import { setTimeout } from 'timers';

let crimeViewStr = '[]';
const publicUtil = publicUtilFunc();

export default {
  components: {
    configureRemoteSelect,
    fullTextSelect,
    fullReasonSelect
    // inputItem
  },
  data() {
    return {
      isInit: false,
      selectWidth: '500px',
      filterModelLoading: false,
      instrumentType: '裁判文书',
      filterList: cloneDeep(defaultFilterList),
      crimeView: [],
      crimeTreeInited: false,
      cirmesList: [],
      lawView: [],
      remoteLoading: false,
      paragraphArr: [],
      showCrimeTree: false,
      saveCoursewareLoading: false,
      getFilterRes: [],
      filedList: cloneDeep(optionFilterList).filter(
        item => !['律师', '律所', '当事人信息', '审判人员'].includes(item.name)
      ),
      defaultDate: moment(),
      matchCourts: [],
      caseTypeList: [],
      procedureTypeList: [],
      switchProcedureTypeList: [],
      cascaderIndex: 0
    };
  },
  watch: {
    casePickType(val) {
      let resValue = [];
      const caseType = find(this.filterList, { name: '案件类型' });
      if (val) {
        resValue = [val];
        const res = find(this.caseTypeList, { name: val });
        if (!res) resValue.unshift('其他');
      }
      caseType.value = resValue;
    }
  },
  props: {
    justFilter: {
      type: Boolean,
      default: false
    },
    defaultFilterArr: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['casePickType']),
    courtLevel() {
      return find(this.filedList, { name: '法院层级' }).value;
    },
    courseFilterTips() {
      return publicUtil.fetchCourseFilterTips({
        // instrumentType: this.instrumentType,
        filterList: this.filterList,
        paragraphArr: this.paragraphArr
      });
    },
    paragraphArrGroup() {
      const groupObj = groupBy(this.paragraphArr, 'groups');
      return Object.keys(groupObj).map(groupName => {
        let arr = [];
        if (this.instrumentType === groupName) {
          arr = groupObj[groupName];
        }
        return { groupName, data: arr };
      });
    },
    natureList() {
      const arr = [
        {
          name: '裁判文书',
          key: 'base_nature',
          data: [...baseNature]
        },
        {
          name: '检察文书',
          key: 'procuratorate_nature',
          data: [...procuratorateNature]
        }
      ];
      const natureItem = arr.find(item => item.name === this.instrumentType);
      return (natureItem && natureItem.data) || [];
    }
  },

  mounted() {
    setTimeout(async () => {
      await this.fetchData();
      await this.initSelect();
      await this.initParagraph();
      this.isInit = true;
    }, 200);

    const used = !!localStorage.getItem('is_used_courseFilter');
    if (!used) {
      localStorage.setItem('is_used_courseFilter', 1);
      this.$refs.toolFirstTip.forEach(el => el.show());
    }
  },

  methods: {
    remoteSelectChange(item, value, showValue) {
      item.value = value;
      item.showValue = showValue;
    },
    changeCaseType(value) {
      this.$store.dispatch('setCasePickType', value[value.length - 1]);
    },
    async fetchCaseTypeList() {
      try {
        this.caseTypeList = [];
        let queryInfo = { term: { 'typename.keyword': '案件类型' } };

        const { hits } = await services.courseware.getCourseCrime({
          size: 5000,
          query: {
            bool: {
              must: [{ ...queryInfo }]
            }
          },
          sort: [{ sort: 'desc' }]
        });

        const caseTypeList = [];
        for (const crimeItem of hits.hits) {
          caseTypeList.push({
            ...crimeItem._source,
            id: crimeItem._id
          });
        }
        this.caseTypeList = Object.freeze(publicUtil.arrayToTree(caseTypeList));
      } catch (err) {
        this.$error(err);
      }
    },
    addSymbolHandle(symbol, item, index) {
      const refItem = this.$refs.paraInputRefs[index];
      const inputEl = refItem.$el.firstElementChild;
      const start = inputEl.childNodes[1].selectionStart;
      item.value = `${item.value.slice(0, start)}${symbol}${item.value.slice(start)}`;
      this.$nextTick(() => {
        refItem.focus();
        inputEl.childNodes[1].selectionStart = start + 1;
        inputEl.childNodes[1].selectionEnd = start + 1;
      });
    },
    crimeViewFilter(crimeView, crimeFilterItem) {
      const arr = [...crimeView, ...crimeFilterItem.value];
      return _.uniqBy(arr, 'id');
    },
    async initParagraph() {
      try {
        this.paragraphArr = await services.labelRelation.getParagraph();
      } catch (err) {
        console.error(err);
      }
    },
    async initMatchCourts() {
      try {
        var reqData = {
          size: 5000,
          query: {
            bool: {
              must: [
                {
                  term: {
                    'typename.keyword': '法院'
                  }
                }
              ]
            }
          }
        };
        let param = {
          url: '/dispose_case/_search',
          method: 'GET',
          formParams: null,
          jsonBody: JSON.stringify(reqData)
        };
        const data = await this.httpPost('sends/configure/search', param);
        if (data && data.statusCode == 1) {
          var arr = [];
          data.data.hits.hits.forEach(v => {
            if (v._source.name !== '最高人民法院') {
              var model = {
                id: v._id,
                value: v._source.name,
                label: v._source.name,
                parentId: v._source.parentId,
                remark: v._source.remark
              };
              arr.push(model);
            }
          });
          this.matchCourts = publicUtil.arrayToTree(arr);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async initCrimeTreeCheck() {
      const crimeItem = find(this.filterList, { name: '案由' });
      if (crimeItem.value.length > 0) {
        const ids = crimeItem.value.map(item => item.id);
        this.$refs.cirmesTreeRef[0].setCheckedKeys(ids);
      }
      await this.$nextTick();
      this.crimeTreeInited = true;
    },
    nodeCheckHandle(item, val) {
      if (!this.crimeTreeInited) {
        return;
      }
      const crimeItem = find(this.filterList, { name: '案由' });
      if (val) {
        crimeItem.value.push(item);
      } else {
        crimeItem.value = crimeItem.value.filter(subItem => subItem.id !== item.id);
      }
    },
    addRes(label) {
      label.result.push({
        keyword: '',
        value: '',
        lawRes: []
      });
    },
    removeRes(label, index) {
      if (label.result.length > 1) {
        label.result.splice(index, 1);
      } else {
        label.result.keyword = '';
        if (label.name === '引用法条') {
          const filterIndex = this.filterList.findIndex(item => item === label);
          console.log(filterIndex);
          this.filterList.splice(filterIndex, 1);
        }
      }
    },
    removeFiled(label) {
      const key = findIndex(this.filterList, { key: label.key });
      key && key !== -1 && this.filterList.splice(key, 1);
    },
    isArrayCheck(arr) {
      if (arr) {
        return Array.isArray(arr);
      } else {
        return false;
      }
    },
    groupByKey(arr, key) {
      if (arr && key) {
        return groupBy(arr, key);
      } else {
        return [];
      }
    },
    showAllParaCheck(arr) {
      if (arr) {
        const hadRes = arr.filter(paraItem => {
          return paraItem.value;
        });
        return hadRes.length > 0;
      } else {
        return false;
      }
    },
    initSelect() {
      let defaultFilterList = this.justFilter
        ? this.defaultFilterArr
        : JSON.parse(sessionStorage.getItem('caseFilterList') || '[]');
      defaultFilterList = defaultFilterList.filter(item => !item.bySearchInput && !item.isOtherFilter);
      if (defaultFilterList.length > 0) {
        // console.log(this.filterList)
        this.filterList.forEach(v => {
          const filterItem = find(defaultFilterList, { name: v.name });
          if (filterItem) {
            v.value = filterItem.value;
            v.result = filterItem.result;
            if (['全文检索', '案由'].includes(filterItem.name)) {
              v.type = filterItem.type || 'and';
            }
          }
        });
        this.filedList.forEach(filedItem => {
          const courseCondition = find(defaultFilterList, { name: filedItem.name });

          if (courseCondition) {
            filedItem.value = courseCondition.value;
            filedItem.result = courseCondition.result;
            this.filterList.push(filedItem);
          }

          if (courseCondition && ['引用法条'].includes(filedItem.name)) {
            filedItem.type = courseCondition.type;
          }
        });
      } else {
        this.filterList.forEach(v => {
          v.resetFunc && v.resetFunc();
        });
      }
    },
    getQuery(options) {
      const { allCaseTotal = false } = options || {};
      const query = {
        bool: {
          must: [],
          must_not: []
        }
      };
      if (!allCaseTotal) {
        const boolKey = this.instrumentType === '裁判文书' ? 'must_not' : 'must';
        query.bool[boolKey].push({
          term: { 'authority.keyword': '检察文书' }
        });
      }
      this.filterList.forEach(filterItem => {
        if (filterItem.inputType === 'version' && filterItem.value) {
          query.bool.must.push({
            term: { version: filterItem.value }
          });
        } else if (filterItem.key === 'base_nature' && (filterItem.value || '').length > 0) {
          if (this.instrumentType === '裁判文书') {
            query.bool.must.push({
              terms: {
                'base_nature.keyword': filterItem.value
              }
            });
          }

          if (this.instrumentType === '检察文书') {
            query.bool.must.push({
              terms: {
                'procuratorate_nature.keyword': filterItem.value
              }
            });
          }
        } else if (filterItem.key === 'mulit_personal_crime') {
          const { singlePersonal, mulitPersonal, singleCrime, mulitCrime } = filterItem.value;
          if (singlePersonal && mulitPersonal) {
            query.bool.must.push({
              range: { defendantSize: { gte: 1 } }
            });
          } else if (singlePersonal) {
            query.bool.must.push({
              term: { defendantSize: 1 }
            });
          } else if (mulitPersonal) {
            query.bool.must.push({
              range: { defendantSize: { gte: 2 } }
            });
          }
          if (singleCrime && mulitCrime) {
            query.bool.must.push({
              range: { crime_reason_length: { gte: 1 } }
            });
          } else if (singleCrime) {
            query.bool.must.push({
              term: { crime_reason_length: 1 }
            });
          } else if (mulitCrime) {
            query.bool.must.push({
              range: { crime_reason_length: { gte: 2 } }
            });
          }
        } else if (
          (filterItem.inputType == 'select' || filterItem.inputType == 'input') &&
          (filterItem.value || '').length > 0
        ) {
          query.bool.must.push({
            [filterItem.key == 'base_caseNumber' ? 'match_phrase' : 'terms']: {
              [`${filterItem.key}${filterItem.key == 'base_caseNumber' ? '' : '.keyword'}`]: filterItem.value
            }
          });
        } else if (filterItem.inputType == 'date' && filterItem.value.length > 0) {
          const dateVal = {};
          if (filterItem.value[0]) {
            dateVal.gte = filterItem.value[0];
          }
          if (filterItem.value[1]) {
            dateVal.lte = filterItem.value[1];
          }
          if (Object.keys(dateVal).length > 0) {
            query.bool.must.push({
              range: {
                [filterItem.key]: dateVal
              }
            });
          }
        } else if (filterItem.inputType == 'matchSelect') {
          if (['全文检索', '引用法条'].includes(filterItem.name)) {
            const contentQuery = {
              bool: {}
            };
            const key = filterItem.type == 'or' ? 'should' : 'must';
            contentQuery.bool[key] = [];
            const contentQueryArr = contentQuery.bool[key];
            filterItem.result.forEach(paragraphItem => {
              if (filterItem.name === '全文检索' && paragraphItem.value) {
                const queryObj = {
                  query_string: {
                    query: this.formatFilterWord(paragraphItem.value),
                    default_operator: 'AND'
                  }
                };
                // 按后端要求修改传参
                if (paragraphItem.keyword) {
                  queryObj.query_string.default_field = paragraphItem.keyword;
                } else {
                  queryObj.query_string.fields = ['para_content', 'base_caseNumber', 'base_title'];
                }
                contentQueryArr.push(queryObj);
              }
              if (filterItem.name === '引用法条' && (paragraphItem.value || paragraphItem.keyword)) {
                contentQueryArr.push({
                  regexp: {
                    [filterItem.key + '.sentence']: `.*?${paragraphItem.keyword}.*?${paragraphItem.value.slice(
                      0,
                      paragraphItem.value.indexOf('条') + 1
                    )}.*?`
                  }
                });
              }
            });
            query.bool.must.push(contentQuery);
          }
        } else if (filterItem.inputType === 'province_city_cascader') {
          const provinceCityShould = [];
          const cityVal = [];
          const provinceVal = [];
          (filterItem.value || []).forEach(filterVal => {
            if (filterVal[1]) {
              cityVal.push(filterVal[1]);
            } else if (filterVal[0]) {
              provinceVal.push(filterVal[0]);
            }
          });
          if (cityVal.length > 0) {
            provinceCityShould.push({
              terms: {
                'base_city.keyword': cityVal
              }
            });
          }
          if (provinceVal.length > 0) {
            provinceCityShould.push({
              terms: {
                'base_province.keyword': provinceVal
              }
            });
          }
          if (provinceCityShould.length > 0) {
            query.bool.must.push({
              bool: { should: provinceCityShould }
            });
          }
        }
      });

      return query;
    },
    changeInstrumentType() {
      ['文书性质', '案件类型', '审理程序', '案由', '全文检索', '引用法条'].forEach(name => {
        const filterItem = this.filterList.find(item => {
          return item.name === name;
        });
        if (!filterItem) {
          return;
        }
        if (['全文检索', '引用法条'].includes(name)) {
          filterItem.result = [
            {
              value: '',
              keyword: ''
            }
          ];
        } else {
          filterItem.value = [];
        }
      });
      this.fetchCrimeData();
    },
    getMustType(val) {
      if (val) {
        const res = val.replace(/-/g, '排除');
        return res;
      } else {
        return '';
      }
    },
    removeFilter({ filterItem, contentArr }) {
      if (['全文检索', '引用法条'].includes(filterItem.name)) {
        const removeKeys = contentArr.map(item => item.keyword);
        filterItem.result = filterItem.result.filter(item => !removeKeys.includes(item.keyword));
        if (filterItem.result.length === 0) {
          filterItem.result.push({ value: '', keyword: '' });
        }
      } else if (filterItem.inputType === 'province_city_cascader') {
        filterItem.data = cloneDeep(provinceJson);
        filterItem.value = [];
      } else if (filterItem.key === 'mulit_personal_crime') {
        filterItem.value = {
          singlePersonal: false,
          mulitPersonal: false,
          singleCrime: false,
          mulitCrime: false
        };
      } else if (filterItem.inputType === 'date') {
        filterItem.value = [];
      } else {
        filterItem.value = '';
      }
    },
    async fetchData() {
      await Promise.all([this.fetchCrimeData(), this.fetchLawData(), this.fetchCaseTypeList()]);
    },
    async fetchLawData() {
      try {
        const { category } = await services.courseware.getLawTree();
        category.buckets.forEach(categoryItem => {
          this.$set(categoryItem, 'id', 'category_' + uniqueId());
          categoryItem.title.buckets.forEach(lawItem => {
            this.$set(lawItem, 'id', 'law_' + uniqueId());
          });
        });
        this.lawView = Object.freeze(category);
      } catch (err) {
        this.$error(err);
      }
    },
    async fetchCrimeData() {
      try {
        this.crimeView = [];

        const caseTypeItem = this.filterList.find(fieldItem => fieldItem.key === 'base_caseType');
        let queryInfo = { term: { 'typename.keyword': '案由' } };
        if (this.instrumentType === '检察文书') {
          queryInfo = { terms: { 'remark.keyword': ['刑事'] } };
        } else if (caseTypeItem && (caseTypeItem.value || []).length > 0) {
          queryInfo = { terms: { 'remark.keyword': caseTypeItem.value } };
        }
        const { hits } = await services.courseware.getCourseCrime({
          size: 5000,
          query: {
            bool: {
              must: [{ ...queryInfo }]
            }
          },
          sort: [{ sort: 'desc' }]
        });

        const crimeView = [];
        for (const crimeItem of hits.hits) {
          crimeView.push({
            ...crimeItem._source,
            id: crimeItem._id
          });
        }
        this.cirmesList = Object.freeze(publicUtil.arrayToTree(crimeView));
        this.crimeView = crimeView.slice(0, 50);
        crimeViewStr = JSON.stringify(crimeView || []);
      } catch (err) {
        this.$error(err);
      }
    },
    handleCrimeNodeClick(data) {
      const crimeItem = find(this.filterList, { name: '案由' });
      crimeItem.value.push(data);
      this.showCrimeTree = false;
    },
    resetHandle() {
      [...this.filterList, ...this.filedList].forEach(item => {
        if (item.resetFunc) {
          item.resetFunc();
        }
      });
      this.$nextTick(() => {
        ['full_procedureType', 'full_base_court', 'fullreason'].forEach(key => {
          this.$refs[key] && this.$refs[key][0].initValue();
        });
      });
      this.$store.dispatch('setCasePickType', '');
      sessionStorage.removeItem('caseFilterList');
    },
    confirmHandle() {
      const filterList = this.filterList
        .filter(v => {
          if (v.key === 'mulit_personal_crime') {
            const haveCheck = Object.keys(v.value).some(key => v.value[key]);
            return haveCheck;
          }
          let haveResult = false;
          if (v.name === '全文检索') {
            haveResult = publicUtil.getFullTextList(v).length > 0;
          } else if (v.name === '引用法条') {
            haveResult = (v.result || []).some(resultItem => resultItem.value || resultItem.keyword);
          } else if (v.name === '案由') {
            haveResult = (v.result || []).filter(i => i.value.length).length;
          } else {
            haveResult = (v.result || []).some(resultItem => resultItem.value);
          }
          if (haveResult) {
            return true;
          }
          return (v.value || '').length > 0;
        })
        .map(v => publicUtil.formatFilterItem({ ...v }));
      if (filterList.length === 0) {
        this.$message.warning('请添加检索条件');
        return;
      }

      const searchTextList = [];
      filterList.forEach(item => {
        if (item.name !== '全文检索') {
          return;
        }
        item.result.forEach(resultItem => {
          resultItem.value && searchTextList.push(resultItem.value);
        });
      });

      if (!this.justFilter) {
        sessionStorage.setItem('caseFilterList', JSON.stringify(filterList));
        services.logger.handleLog({ operateName: '高级检索', otherParams: { info: searchTextList } });
      }
      this.$emit('filter', filterList);
    },
    saveCoursewareHandle() {
      this.saveCoursewareLoading = true;
      const query = this.getQuery();
      const filterList = this.filterList.filter(v => {
        if (v.key === 'mulit_personal_crime') {
          const haveCheck = Object.keys(v.value).some(key => v.value[key]);
          return haveCheck;
        }
        let haveResult = false;
        if (v.name === '引用法条') {
          haveResult = (v.result || []).some(resultItem => resultItem.value || resultItem.keyword);
        } else {
          haveResult = (v.result || []).some(resultItem => resultItem.value);
        }
        if (haveResult) {
          return true;
        }
        return (v.value || '').length > 0;
      });
      this.$emit('saveCoursewareHandle', {
        query: { query: { ...query } },
        condition: filterList,
        totalCount: this.filterCount,
        instrumentType: this.instrumentType
      });
    },
    addFields(item) {
      const fieldModel = this.hadFileds(item);
      if (!fieldModel) {
        this.filterList.push(item);
        this.$nextTick(() => {
          this.$refs.coursePaneRef.scrollTop = 9999;
        });
      }
    },
    hadFileds(item) {
      const fieldModel = find(this.filterList, { name: item.name });
      return fieldModel;
    },
    multSelectHandle(type) {
      if (type === 'base_caseType') {
        const crimeItem = this.filterList.find(fieldItem => fieldItem.key === 'fullreason');
        crimeItem && (crimeItem.value = []);
        this.$nextTick(() => {
          this.fetchCrimeData();
        });
      }
      const filterItemEL = this.$refs[type][0];
      filterItemEL.blur && filterItemEL.blur();
    },
    async remoteMethod(query, val) {
      try {
        if (query !== '') {
          // const lawItem = find(this.filterList, { name: '引用法条' });
          const res = await services.courseware.getFilterLaw({
            title: val.keyword,
            search: query
          });
          const lawRes = [];
          res.hits.forEach(v => {
            lawRes.push({ id: v._id, highlight: v.highlight, ...v._source });
          });
          val.lawRes = lawRes;
        }
      } catch (err) {
        this.$error(err);
      }
    },
    async reasonRemoteMethod(keyword) {
      try {
        let crimeView = JSON.parse(crimeViewStr);
        if (!keyword) {
          this.crimeView = crimeView.slice(0, 50);
          return;
        }

        const zhSymbolArr = keyword.match(/[\u4e00-\u9fa5]/g) || [];
        this.crimeView = crimeView
          .filter(item => {
            if (item.name.includes(keyword)) {
              return true;
            }
            return zhSymbolArr.length < 1 ? false : zhSymbolArr.every(zhSymbol => item.name.includes(zhSymbol));
          })
          .slice(0, 50);
      } catch (err) {
        this.$error(err);
      }
    }
  }
};
</script>
<style lang="less">
.el-select .el-tag__close.el-icon-close {
  background-color: #c0c4cc !important;
}

.tooltip-paragraph-content {
  transform: translateX(42.5px) translateY(20px);
}

.law-pop-select {
  max-width: 500px;

  .el-select-dropdown__item {
    line-height: 22px;
    padding: 10px;
    height: auto;
  }
}

.course-create-input-popper {
  // width: 500px !important;

  .el-autocomplete-suggestion__list > li {
    &:hover {
      background-color: #fff;
    }
  }

  .popper__arrow {
    margin-left: 230px;
  }
}

.cirme-input-popper {
  // width: 580px !important;
}

.course-create-input-tip {
  cursor: auto;

  .blue {
    color: #2c7ddc;
  }

  .course-create-input-tip-title {
    font-size: 12px;
    color: rgba(#606266, 0.8);
    height: 30px;
    line-height: 30px;
  }

  .course-create-input-tip-item {
    font-size: 12px;
    color: #606266;
    min-height: 26px;
    line-height: 20px;
    white-space: normal;
    margin-bottom: 10px;

    .symbol-btn {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #e42626;
      background-color: rgba(228, 38, 38, 0.1);
      cursor: pointer;
    }
  }
}
</style>
<style lang="less" scoped>
@menuWidth: 360px;

.container {
  box-sizing: border-box;
  position: relative;
}

/deep/ .course-panel {
  padding: 46px @menuWidth 20px 120px;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;

  .el-select__tags {
    input[type='text'] {
      border: none;
    }
  }

  .el-input {
    & > input[type='text'] {
      border-radius: 4px;
    }

    &.el-input-group {
      & > input[type='text'] {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  .course-panel-body {
    color: #2c3443;

    .desc {
      margin-bottom: 18px;

      .label {
        font-size: 16px;
        margin-right: 10px;
      }

      .word {
        font-size: 12px;
        color: #77839e;
      }
    }
  }

  .course-panel-item {
    line-height: 35px;
    margin-bottom: 20px;
    @labelWidth: 90px;

    .label {
      width: @labelWidth;
      display: inline-block;
    }

    .course-panel-item-tip {
      width: 100%;
      margin-left: calc(@labelWidth + 5px);
      font-size: 12px;
      color: #999;
    }

    .operation {
      position: relative;
      top: 2px;
      font-size: 20px;
      color: #999;
      margin-right: 5px;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
    }

    .para-children {
      position: relative;

      .group-type-content {
        position: absolute;
        left: 12px;
        font-size: 12px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        user-select: none;
      }

      &::after {
        content: '';
        display: inline-block;
        background: rgba(217, 221, 228, 1);
        width: 1px;
        height: 100%;
        position: absolute;
        left: 20px;
        top: 2px;
      }
    }

    .input {
      display: inline-block;

      &.para-search {
        margin-top: 5px;

        &:first-child {
          margin-top: 0;
        }
      }

      .left-select {
        input {
          position: relative;
          left: 4px;
          border-right-width: 0;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        .el-input__inner:focus {
          border-color: #dcdfe6 !important;
        }

        &.is-focus {
          input {
            border-color: #dcdfe6 !important;
          }
        }
      }

      .right-select {
        // .el-input__inner:focus
        input {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }

    &-wrapper {
      display: inline-block;

      .mulit-personal-crime {
        display: inline-block;

        .mulit-personal-crime-content {
          display: flex;
          justify-content: space-between;
          width: 500px;

          .personal-crime-checkbox {
            width: 115px;
            line-height: 20px;
            margin: 0;
            margin-left: 0px !important;
          }
        }
      }
    }

    .crime-tree {
      position: relative;

      ::v-deep .crime-select {
        .el-select__tags {
          max-width: 350px !important;
        }
      }

      .crime-tree-btn {
        position: absolute;
        right: 10px;
        background-color: #fff;
        z-index: 10;
        height: 80%;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .crime-tree-panel {
        width: 100%;
        position: absolute;
        left: 0;
        border: 1px solid #d2d8e3;
        z-index: 99;
        background: #fff;
        max-height: 500px;
        overflow-y: auto;
      }
    }
  }
}

.course-panel-menu {
  box-sizing: border-box;
  position: absolute;
  top: 1px;
  right: 0;
  bottom: 57px;
  width: @menuWidth;
  background-color: #fafafa;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 0px;

  .menu-title-text {
    color: #3d465a;
    line-height: 20px;
    font-size: 14px;
    margin-left: 25px;
    margin-bottom: 16px;
  }

  .new-filter-ul {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    // gap: 16px 24px;
    padding: 0 24px;

    .new-filter-item {
      box-sizing: border-box;
      width: calc(50% - 12px);
      line-height: 36px;
      background: #f8fafd;
      border-radius: 4px;
      min-width: 90px;
      padding: 0 10px;
      color: #606266;
      cursor: pointer;
      background-color: #fff;
      box-shadow: 0px 2px 4px 0px rgba(129, 150, 180, 0.16);
      margin-bottom: 16px;

      &:nth-child(odd) {
        margin-right: 24px;
      }

      & > span {
        margin-right: 10px;
      }

      &.disabled-filter-item {
        cursor: not-allowed;
        background-color: #ccc;
        box-shadow: none;
      }
    }
  }
}

.panel-item-warp {
  position: relative;
  flex: 1;
  .text-group-type {
    position: absolute;
    left: -18px;
    font-size: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    user-select: none;

    .group-type-btn {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      .group-text {
        color: #999999;
        background-color: #f5f5f5;
        line-height: 20px;
        padding: 0 2px;

        &.active {
          color: #e42626;
          background-color: #ffeaea;
        }
      }

      &.not-allowed {
        cursor: not-allowed;
      }
    }
  }

  .line {
    display: inline-block;
    background: #ddd;
    width: 1px;
    height: 100%;
    position: absolute;
    left: -11px;
    top: 50%;
    transform: translateY(-50%);
    .line-item {
      contain: '';
      display: block;
      height: 1px;
      width: 10px;
      background: #ddd;
      position: relative;
    }
    .line-item-top {
      position: absolute;
      top: 0;
    }
    .line-item-bottom {
      position: absolute;
      bottom: 0;
    }
  }
}
.para-content-body {
  position: relative;
  flex: 1;
  width: 0;

  .group-type-content {
    position: absolute;
    left: -18px;
    font-size: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    user-select: none;

    .group-type-btn {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      .group-text {
        color: #999999;
        background-color: #f5f5f5;
        line-height: 20px;
        padding: 0 2px;

        &.active {
          color: #e42626;
          background-color: #ffeaea;
        }
      }

      &.not-allowed {
        cursor: not-allowed;
      }
    }
  }

  &::after {
    content: '';
    display: inline-block;
    background: rgba(217, 221, 228, 1);
    width: 1px;
    height: 100%;
    position: absolute;
    left: -11px;
    top: 2px;
  }
}

.normal-footer {
  text-align: center;
  line-height: 35px;
  border-top: 1px solid #e6e6e6;
  padding: 10px 20px;

  .filter-count {
    border-left: 1px solid #e6e6e6;
    margin-left: 10px;
    padding-left: 10px;
    font-size: 14px;

    .blue {
      color: #409eff;
    }

    .green {
      color: #67c23a;
    }

    .red {
      color: #f56c6c;
    }

    .question-icon {
      color: rgba(#3d465a, 0.4);
      margin-left: 2px;
    }
  }
}

.condition-panel {
  .condition-item {
    display: inline-block;
    padding: 0 12px;
    line-height: 28px;
    color: #1991fb;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #1991fb;
    margin: 0 10px 10px 0;

    .close-btn {
      margin-left: 6px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
.province-city-cascader,
.procedureType-cascader {
  .el-checkbox__input {
    &.is-disabled {
      .el-checkbox__inner {
        background-color: #fff;

        &::after {
          border-color: #dcdfe6;
          transform: rotate(45deg) scaleY(1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cases/courseFilter.vue